export const createPlaceTreeAutomation = () => ({
  mode: 'automatic', nearbyCount: 24, eventCount: 40,
  started: false, complete: false, stage: '',
});

export const validateAutomationCounts = ({ nearbyCount, eventCount }) => {
  for (const [label, value] of [['Nearby adventure place count', nearbyCount], ['Event count', eventCount]]) {
    if (value === '' || value === null || value === undefined || !Number.isInteger(Number(value)) || Number(value) < 0 || Number(value) > 200) {
      throw new Error(`${label} must be a whole number between 0 and 200.`);
    }
  }
  return { nearbyCount: Number(nearbyCount), eventCount: Number(eventCount) };
};

export const retryPlaceTreeRequest = async (request, { onRetry = () => {}, shouldStop = () => false,
  wait = ms => new Promise(resolve => setTimeout(resolve, ms)) } = {}) => {
  for (let attempt = 0; ; attempt++) {
    try { return await request(); }
    catch (error) {
      const status = Number(error.status ?? error.statusCode);
      const transient = status === 0 || status === 429 || status >= 500 ||
        /network|fetch failed|timeout|timed out|ECONNRESET|ECONNREFUSED|UND_ERR|temporarily unavailable|can.?not communicate/i.test(error.message || String(error));
      if (!transient || attempt >= 2 || shouldStop()) throw error;
      onRetry(attempt + 1, error);
      await wait(1000 * (attempt + 1));
      if (shouldStop()) throw error;
    }
  }
};
